<template>
  <v-card flat class="card-bg rounded-20 mt-5 pb-5">
    <v-toolbar class="transparent" flat dense>
      <v-toolbar-title class="title-font"> INVOICE HISTORY </v-toolbar-title>
    </v-toolbar>
    <v-card flat class="mx-4 rounded-10">
      <v-card-text v-if="loading" class="text-center">
        <v-progress-circular indeterminate color="primary" />
      </v-card-text>
      <v-data-table
        :headers="headers"
        :items="invoices || []"
        :items-per-page="5"
        v-if="!loading"
      >
        <template v-slot:[`header.invoice_number`]="{ header }">
          {{ header.text }}
          <v-tooltip top class="rounded-10">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1 pb-1" v-bind="attrs" v-on="on">
                mdi-cursor-default-click
              </v-icon>
            </template>
            <span> Click ID to view Invoice Details. </span>
          </v-tooltip>
        </template>
        <template v-slot:[`header.url`]="{ header }">
          {{ header.text }}
          <v-tooltip top class="rounded-10">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1 pb-1" v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>
              Open to view payment details, download invoice and receipt.
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.invoice_number`]="{ item }">
          <div style="white-space: nowrap">
            <v-tooltip top class="rounded-10">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="ml-n1 px-1"
                  @click="openDetail(item)"
                >
                  {{ item.invoice_number }}
                </v-btn>
              </template>
              <span> Click to view details. </span>
            </v-tooltip>
            <v-tooltip top class="rounded-10">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="!item.paid"
                  color="warning"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-alert
                </v-icon>
              </template>
              <span> This invoice has not been paid. </span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.invoiced_at`]="{ item }">
          {{ item.invoiced_at | luxon({ output: "date_short" }) }}
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          $ {{ item.amount }}
        </template>
        <template v-slot:[`item.pdf`]="{ item }">
          <a :href="item.pdf">PDF</a>
        </template>
        <template v-slot:[`item.url`]="{ item }">
          <a :href="item.url" target="_blank">Open Payment Page</a>
          <v-icon class="ml-1 pb-2" color="primary" x-small>
            mdi-open-in-new
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
    <InvoiceDetailDialog v-model="dialog" :invoice="selectedInvoice" />
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import InvoiceDetailDialog from "../shared/InvoiceDetailDialog.vue"

export default {
  name: "InvoiceHistory",

  components: { InvoiceDetailDialog },

  data() {
    return {
      loading: false,
      dialog: false,
      selectedInvoice: null,
      headers: [
        {
          text: "Invoice ID",
          value: "invoice_number"
        },
        {
          text: "Issued",
          value: "invoiced_at"
        },
        {
          text: "Amount (ex. Tax)",
          value: "amount"
        },
        {
          text: "Download (PDF)",
          value: "pdf"
        },
        {
          text: "Payment Page",
          value: "url"
        }
      ]
    }
  },

  watch: {
    invoices(val) {
      if (val) this.loading = false
    },

    dialog(val) {
      if (!val) this.selectedInvoice = null
    }
  },

  computed: {
    ...mapGetters(["invoices", "inArrears", "inboxItems"])
  },

  methods: {
    ...mapActions(["triggerReload", "setSelectedOrder"]),

    openDetail(invoiceItem) {
      this.selectedInvoice = invoiceItem
      this.dialog = true
    }
  },

  mounted() {
    this.loading = true
    if (this.invoices) this.loading = false
    else this.triggerReload("invoices")
  }
}
</script>
